import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { SeoStrip } from './components/SeoStrip';
import { Header } from './components/Header';
import { SiteFooter } from './components/SiteFooter';
import { Home } from './pages/Home';
import { TheEastEndWay } from './pages/TheEastEndWay';
import { Services } from './pages/Services';
import { ServiceCategory } from './pages/ServiceCategory';
import { ServiceDetail } from './pages/ServiceDetail';
import { Specials } from './pages/Specials';
import { BrakeSpecial } from './pages/specials/BrakeSpecial';
import { AcSpecial } from './pages/specials/AcSpecial';
import { OilChangeSpecial } from './pages/specials/OilChangeSpecial';
import { Financing } from './pages/Financing';
import { Reviews } from './pages/Reviews';
import { Contact } from './pages/Contact';
import { NotFound } from './pages/NotFound';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { SmsTerms } from './pages/SmsTerms';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  }, [pathname]);
  return null;
}
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3rcj31sdk3h1v">
      <ScrollToTop data-id="element-1" data-mp="3rdaqgfx028h2" />
      <div className="w-full bg-white font-sans" data-id="element-2" data-mp="3rcsyhvhdegey">
        <SeoStrip data-id="element-3" data-mp="5or2zhbcs60" />
        <Header data-id="element-4" data-mp="6817u0q2c9h" />
        <main data-id="element-5" data-mp="4n5w26l2pak">
          <Routes data-id="element-6" data-mp="56ntiw8hdol">
            <Route path="/" element={<Home data-id="element-8" data-mp="2zld1r8m3ndb0" />} data-id="element-7" data-mp="7suzhf7pr6a" />
            <Route path="/the-east-end-way" element={<TheEastEndWay data-id="element-10" data-mp="2zn6b4vo3kbmp" />} data-id="element-9" data-mp="2zm4ywnvchj3e" />
            <Route path="/services" element={<Services data-id="element-12" data-mp="33nges1of2pye" />} data-id="element-11" data-mp="33mf0zpg0npcz" />
            <Route path="/services/:categorySlug" element={<ServiceCategory data-id="element-14" data-mp="38l05w267qx7r" />} data-id="element-13" data-mp="33myjb79kwfrj" />
            <Route path="/services/:categorySlug/:serviceSlug" element={<ServiceDetail data-id="element-16" data-mp="3dii3iwes5q0g" />} data-id="element-15" data-mp="3dkuufz2inapn" />
            <Route path="/specials" element={<Specials data-id="element-18" data-mp="nv12m6045cbh" />} data-id="element-17" data-mp="nwc1psim5vw9" />
            <Route path="/specials/brake-inspection" element={<BrakeSpecial data-id="element-20" data-mp="ssss6tdacmci" />} data-id="element-19" data-mp="nxx0jubyo0zx" />
            <Route path="/specials/ac-pressure-test" element={<AcSpecial data-id="element-22" data-mp="34napqbl6vw3" />} data-id="element-21" data-mp="35ypsmahfq2i" />
            <Route path="/specials/oil-change" element={<OilChangeSpecial data-id="element-24" data-mp="3ucjcjtti8btq" />} data-id="element-23" data-mp="3uct43lu76r1j" />
            <Route path="/financing" element={<Financing data-id="element-26" data-mp="d3cwhu6lt0hm" />} data-id="element-25" data-mp="d57hf8hvkslp" />
            <Route path="/reviews" element={<Reviews data-id="element-28" data-mp="85ully910b6z" />} data-id="element-27" data-mp="d2l7j27ii10b" />
            <Route path="/contact" element={<Contact data-id="element-30" data-mp="86cqtkdo1zr1" />} data-id="element-29" data-mp="86mg15qw02vo" />
            <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-32" data-mp="3gmfu7dxqx29k" />} data-id="element-31" data-mp="3glea6jyr55fp" />
            <Route path="/sms-terms" element={<SmsTerms data-id="element-34" data-mp="3bmjq7ep1tau0" />} data-id="element-33" data-mp="3glo2wfb6lqp3" />
            <Route path="*" element={<NotFound data-id="element-36" data-mp="3bnuvxk220snr" />} data-id="element-35" data-mp="3bncqbwti5236" />
          </Routes>
        </main>
        <SiteFooter data-id="element-37" data-mp="3qbpl4qgusew3" />
      </div>
    </BrowserRouter>;
}